import { EmtAvatar, EmtAvatarProps } from "./EmtAvatar";

export interface EmtAvatarLetterProps extends EmtAvatarProps {
  showLetter?: boolean;
  letter?: string;
  active?: boolean;
}

export function EmtAvatarLetter(props: EmtAvatarLetterProps) {
  const { showLetter = false, letter, active, ...rest } = props;

  return (
    <EmtAvatar
      {...rest}
      size="small"
      sx={{
        backgroundColor: active ? "#F6F6F6" : "#E8E8EA",
        color: "#A5A3A9",
        fontSize: "18px",
        fontWeight: "bold",
      }}
    >
      {showLetter && letter ? letter.charAt(0).toUpperCase() : undefined}
    </EmtAvatar>
  );
}
